const ru_RU = {
    homepage_title: 'Скачать CalendarTask мобильную версию по QR-коду',
    homepage_slogn: 'CalendarTask мобильная версия',
    homepage_ios_download: 'App Store на проверке...',
    homepage_download: 'Скачать',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Скачать CalendarTask мобильную версию по QR-коду',
    phonedownload_slogan: 'Синхронизация с ПК и планшетом, заметки везде',
    phonedownload_send_vip: 'Установите приложение и получите VIP-подписку',
    phonedownload_screenshot: 'Снимок экрана',
    phodedownload_macos: 'CalendarTask версия macOS',
    phodedownload_windows: 'CalendarTask версия Windows',
    phodedownload_otherbutton: 'Смотреть сейчас',
    phodedownload_about: 'Связаться с нами',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Без рекламы',
    feature_easy: 'Месячный вид, просто и удобно',
    feature_reminder: 'Пользовательское напоминание',
    feature_countdown: 'Обратный отсчёт годовщины',

    vip_task_succ: 'Успех. Скачайте приложение для активации VIP',
    vip_task_error: 'Получение не удалось',

    group_slogn: 'Приглашение CalendarTask команда',

    tt_title: 'CalendarTask',
    tt_share_1: 'Поделились с вами',
    tt_share_2: 'Расписание',
    tt_share_show_1: 'Отсканируйте QR-код приложением "CalendarTask", ПК и телефон покажут',
    tt_share_show_2: 'расписание',
    tt_share_scan_1: 'Сканировать',
    tt_share_scan_2: 'приложением "CalendarTask"',
    tt_share_succ: 'Синхронизация успешна',

    v2_copyright: 'Связаться service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Все права защищены.',
    v2_download_appstore: 'Скачать в App Store',
    v2_download_googleplay: 'Доступно в Google Play',

    v2_main_title: 'CalendarTask Мобильный',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Мобильный',
    v2_main_description: 'Найдите <span class="name">CalendarTask</span> в App Store или Google Play',
    v2_download_ios: 'Скачать iOS',
    v2_download_android: 'Скачать Android',
    v2_download_harmonyos: 'Скачать HarmonyOS',
    v2_sync_status: 'Синхронизация завершена! 1 загружено, 0 скачано',
    v2_feature_title: 'Синхронизация данных нескольких устройств',
    v2_feature_description: 'Синхронизация между телефоном, планшетом и ПК'
};
export default ru_RU;
